import React, { createContext, useEffect, useState } from "react";
import useListing from "../apis/services/useListing";
const LoaderContext = createContext();

const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [count,setCount] = useState(0);
  const [isRedirectTool,setIsRedirectTool] = useState(false)
  const [isFromBot,setIsFromBot] = useState(false)
  const [showRedirect,setShowRedirect] = useState(false)
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "danger",
  });
  const { list: points, getList } = useListing("sector");

  const location = window.location.pathname;


  useEffect(() => {
    getList();
    
  }, []);

  useEffect(() => {
    if(location == '/bbbee-investments'){
      setIsFromBot(true)
    }
  }, [location])

  const setLoader = (status) => setLoading(status);
  const setProgessCount = (count) => setCount(count);
  const setRedirectToTool = (redirect) => setIsRedirectTool(redirect);
  const setShowRedirects = (redirect) => setShowRedirect(redirect);
  const setIsFromBots = (value) => {
    setIsFromBot(value);
    localStorage.setItem(
      "bot",
      value
    );
  };
  // const setFromBot = (redirect) => setIsFromBot(redirect);
  return (
    <LoaderContext.Provider value={{ toast,loading, points,count,isRedirectTool,isFromBot, showRedirect,setToast, setLoader,setProgessCount,setRedirectToTool, setIsFromBots, setShowRedirects}}>
      {children}
    </LoaderContext.Provider>
  );
};

// const withLoader = (Child) => (props) =>
//   (
//     <LoaderProvider.Consumer>
//       {(context) => <Child {...props} {...context} />}
//     </LoaderProvider.Consumer>
//   );

export { LoaderProvider, LoaderContext /*withLoader*/ };
